export enum BRAND {
  TOPDANMARK = 'TD'
}
export enum PRODUCTKEY {
  INJURY = 'INJURY'
}

export enum PAYMENT_FREQ {
  MONTHLY = 'monthly',
  YEARLY = 'yearly'
}

export enum PAYMENT_FREQ_DK {
  MONTHLY = 'Månedligt',
  YEARLY = 'Årligt'
}

export enum PREMIUMRATE {
  MONTHLY = 12,
  YEARLY = 1
}

export enum YES_NO {
  YES = 'ja',
  NO = 'nej'
}

export type TRequestStatus = 'none' | 'in-progress' | 'logged-on-success' | 'logged-on-error' | 'not-logged-on';

export interface IRequestInfo<T> {
  progress: TRequestStatus;
  value: T;
}

export enum FLOW {
  NOT_SET = 'NOT_SET',
  CURRENT = 'CURRENT',
  DROP_DOWN_ON_FOCUS = 'DROP_DOWN_ON_FOCUS'
}

export const flowConfig = [
  { index: 0, flow: FLOW.CURRENT },
  { index: 1, flow: FLOW.DROP_DOWN_ON_FOCUS }
];
